import { Component, OnInit, ViewChild, HostListener} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import * as $ from 'jquery';
import { ActivatedRoute, Router } from '@angular/router';
import { DateObject, Document_Upload_File, ModuleMenu, GM_APP, SCREEN_CONTROL, SCREEN_RESPONSE, ScreenResponseModel } from 'src/app/models/common';
import { HeadService } from 'src/app/services/common/headservice';
import { Observable, of, tap } from 'rxjs';
import { serviceConstants } from 'src/app/constants/service.constants';
import { IDeactivateComponent } from 'src/app/services/common/deactivate-guard.service';
import { FileService } from 'src/app/services/file.service';
import { DatePipe } from '@angular/common';
import * as _ from 'lodash';

@Component({
  selector: 'app-grants-general-information-charitable',
  templateUrl: './grants-general-information-charitable.component.html',
  styleUrls: ['./grants-general-information-charitable.component.scss']
})
export class GrantsGeneralInformationCharitableComponent implements OnInit, IDeactivateComponent {

  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  generalInfoForm: UntypedFormGroup;
  staticformFields: any;
  userType: string = "";
  permission: string = "";
  CharityAppID: string;
  menudata: ModuleMenu;
  therapeuticAreas$: Observable<any>;
  therapeuticAreas1: any = [];
  IsPreviousFundList: any = [];
  previouslyReceivedFundDD$: Observable<any>;
  ProgramStartDate: any;
  ProgramEndDate: any;
  minPStartDate: Date;
  maxPStartDate: Date | undefined;
  minPEndDate: Date
  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Full_Start_Date: DateObject;
  Full_End_Date: DateObject;
  currencyType: string = '$';
  grantsapp: GM_APP;
  appid: string;
 
  uploadedFiles: Document_Upload_File[] = [];
  Application_Type_ID: string = "";
  Record_ID: string;

  IsFormToched = false;
  isDateModified: boolean = false;
  Full_Date: DateObject;
  tooltipValue: string;
  submittedresponse: SCREEN_RESPONSE[] = [];
  ScreenName :string;
  SCREEN_MODEL: any = null;

  isSubmitVisible : boolean = false;
  disableSave: boolean = false;
  createdUser: any;
  ScreenSubmitStatus: boolean = false;  
  IsRecordSaved:boolean = false;
  Id : string;
  status : number = 0;
  user : any;
  Currency_ID: string = '';

  constructor(
    private readonly commonService: CommonService,
    private readonly userService: UserService,
    private readonly DatashareSerivce: GrantsDatashareService,
    private readonly router: Router,
    private readonly activatedrouter: ActivatedRoute,
    private header: HeadService,
    private readonly summaryService: GrantsSummaryService,
    public fileService: FileService,
    public datepipe: DatePipe
  ) {
    this.currencyType = this.userService.getGrantCharitableCurrencySymbol();
    this.Application_Type_ID = activatedrouter.snapshot.queryParams['ApplicationType'];
  }

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    this.IsFormToched = true;
  }

  ngOnInit() {
    if (this.Application_Type_ID == null || this.Application_Type_ID == undefined || this.Application_Type_ID == "") {
      this.DatashareSerivce.Application_Type_ID.subscribe(x => {
        this.Application_Type_ID = x;
      });
    }
     if (this.Currency_ID == null || this.Currency_ID == undefined || this.Currency_ID == "") {
      this.DatashareSerivce.Currency_ID.subscribe(x => {
        this.Currency_ID = x;
      });
    }
    this.userType = this.userService.getUserType();
    this.DatashareSerivce.GrantApplicationID.subscribe(x => {
      this.appid = x;
    });
   this.grantsapp = this.commonService.getGrantsApp();
    this.appid = this.commonService.appId;
    //this.getStaticFiledsData('GCH01');
    this.user = this.userService.getUserDetais();
    this.GetScreenConfigControls('GCH01');
    this.fetchDropDowns();
    this.fetchGeneralInfo();
    if(!this.isSubmitVisible){
      this.disableSave = false;
    }

    this.permission = this.commonService.getPagePermission("GCH01").toLowerCase();
    if (this.permission == null || this.permission == undefined || this.permission == ''){
       const intervalId = setInterval(() => {
         this.permission = this.commonService.getPagePermission("GCH01").toLowerCase();
         if (this.permission != null && this.permission != undefined && this.permission != '') {
           clearInterval(intervalId);
         }
       }, 1000);
   }
   
  }

  private fetchDropDowns() {
    this.fetchTherapeuticAreas();
  }

  fetchTherapeuticAreas() {

    this.summaryService.GetMasterScreenData("api/GMGeneralInfoCharitable/GetMasterData?ApplicationID="
      + this.CharityAppID).subscribe(result => {
        if (result) {
          this.therapeuticAreas1 = result.MasterData1;
          this.therapeuticAreas1 = [{ label: "Select", value: null }].concat(
            this.therapeuticAreas1);
          this.IsPreviousFundList = result.MasterData2;
          this.IsPreviousFundList = [{ label: "Select", value: null }].concat(
            this.IsPreviousFundList);
        }
      })
  }

  private fetchGeneralInfo() {
    this.summaryService.getCharityGeneralInfo("api/GMGeneralInfoCharitable/Fetch?RecordID=" + this.appid)
      .subscribe({
        next: summary => {
          if (summary != null && summary != undefined) {
            this.status = summary["STATUS"];
            this.createdUser = summary["RECORD_CREATED_BY"];
            //this.permission = summary["PERMISSION"];
           if(summary["RECORD_CREATED_BY"] == null){
             this.IsRecordSaved = false;
           }
           else{
            this.IsRecordSaved = true;
           }

      if((summary["SUBMIT_STATUS"] == 1 ) || (this.user.ID == summary["RECORD_CREATED_BY"]) || this.isSubmitVisible == false ){
            this.CharityAppID = summary.ID;
           
            this.BindDataToDynamicControls();
            this.BindDataToStaticControls(summary);
            this.ScreenSubmitStatus = summary["SUBMIT_STATUS"] == 1 ? true : false;
        }
     
        if(this.grantsapp?.STATUS > 1 && summary["SUBMIT_STATUS"] == 1){
          this.disableSave = true;
        }

        if(!this.isSubmitVisible){
          this.disableSave = false;
        }
      }
        },
        error: err => {
          console.error(err);
        }
      });
  }

  

  SaveGeneralInfo(SaveType : string) {
    if(this.IsRecordSaved && this.user.ID != this.createdUser && this.ScreenSubmitStatus==false){     
      return this.commonService.ValidationBanner("This screen is currently being worked on by another user. You are not permitted to make changes at this time.");
     }

    if (this.validateControls()) {
      
      for (let i = 0; i < this.staticformFields.length; i++) {
        switch (this.staticformFields[i].CONTROL) {
          case 6:
            let seletedItem = "";
            for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
              if (this.staticformFields[i].SourceItems[c].Checked == true) {
                if (seletedItem == "")
                  seletedItem = this.staticformFields[i].SourceItems[c].value;
                else
                  seletedItem = seletedItem + "," + this.staticformFields[i].SourceItems[c].value;
              }
            }
            this.staticformFields[i].ANSWER = seletedItem;
            break;
          case 8:
            this.staticformFields[i].UploadedDocuments = [];
            if (this.staticformFields[i].UploadFiles) {
              for (let j = 0; j < this.staticformFields[i].UploadFiles.length; j++) {
                if (this.staticformFields[i].UploadFiles[j].Status == "Add" || this.staticformFields[i].UploadFiles[j].Status == "Delete") {
                  this.staticformFields[i].UploadedDocuments.push(this.staticformFields[i].UploadFiles[j]);
                }
              }
              this.staticformFields[i].ANSWER = null;
              this.staticformFields[i].ControlValue = null;
            }
            break;
          case 10:
            let SelectedValues = this.staticformFields[i].ControlValue;
            if (SelectedValues != null && SelectedValues != undefined && SelectedValues.length > 0) {
              this.staticformFields[i].ANSWER = SelectedValues.join(",");
            }
            else {
              this.staticformFields[i].ANSWER = "";
            }
            this.staticformFields[i].SUBFIELDNAME = "";
            //this.staticformFields[i].ControlValue = null;
            break;
          case 5:
            let controlanswer = this.staticformFields[i].ControlValue;
            if (controlanswer != null && controlanswer != "" && controlanswer != undefined) {
              let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
              this.staticformFields[i].ANSWER = formd;
            }
            else {
              this.staticformFields[i].ANSWER = controlanswer;
            }
            break;
          default:
            this.staticformFields[i].ANSWER = this.staticformFields[i].ControlValue;
            break;
        }
      }
      let uploadData = new FormData();
      let FinalControls=_.cloneDeep(this.staticformFields);
        FinalControls.forEach((item)=>{
          switch (item.CONTROL) {
            case 10:
              item.ControlValue=null;
              break;
          }
        });
      uploadData.append("ScreenControlsData", JSON.stringify(FinalControls));
      uploadData.append("Appid", this.appid);
      uploadData.append("ModuleID", "4");
      uploadData.append("APPLICATION_TYPE_ID", this.Application_Type_ID);
       uploadData.append("Currency_ID", this.Currency_ID);
      uploadData.append("Is_fromGeneralInformation", "yes");

      

      if (SaveType == "Save") {
        if(this.isSubmitVisible == true && this.grantsapp?.STATUS > 1 && this.ScreenSubmitStatus == false) {
          uploadData.append("SUBMIT_STATUS", "0");
        } 
        else {
          uploadData.append("SUBMIT_STATUS", "1");
        }
      } else{
        uploadData.append("SUBMIT_STATUS", "1");
      }


      if (this.appid == "" || this.appid == null) {
        this.summaryService.SaveCharityGeneralInfo('api/GMGeneralInfoCharitable/Insert', uploadData).subscribe((result) => {
          // .subscribe({
          // next: result => {
          var tempID = result.Data;
          this.CharityAppID = tempID;
          this.appid = result.Data;
          this.DatashareSerivce.setGrantApplicationID(tempID);
          if (result.Status === 0) {
            //this.getScreenDataEdit();
            this.IsFormToched = false;
            this.commonService.SuccessBanner(this.ScreenName + " saved successfully.");
            this.fetchGeneralInfo();
            this.commonService.refreshApplicationPage(this.appid,'grants');
          }
          
          error: err => {
            console.error(err);
          }
        });
      }
      else {
        uploadData.append("ApplicationID", this.appid);

        this.summaryService.SaveCharityGeneralInfo('api/GMGeneralInfoCharitable/Update', uploadData)
          .subscribe({
            next: result => {
              if (result.Status === 0) {
                this.IsFormToched = false;
                this.commonService.SuccessBanner(this.ScreenName + " saved successfully.");
                this.fetchGeneralInfo();
              }
              else if (result.ErrorCode === "NOCONTROLS" || result.ErrorCode != null) {
                if (result.ErrorCode === "NOCHANGES")
                  this.commonService.ValidationBanner(result.Message);
                
              }
              else {
                this.commonService.ValidationBanner(result.Message);
              }
              
            },
            error: err => {
              console.error(err);
            }
          });
      }
    }
  }
  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }

  canExit() {
    if (this.IsFormToched) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }
  refreshPage(id: string, transactionID: string) {

    this.summaryService.getCharityAppSummary("api/common/getgrantsapp/" + id).subscribe(data => {
      this.commonService.appId = data.ID;
      this.commonService.ScreenID = transactionID;
      this.commonService.setGrantsApp(data);
      this.menudata = new ModuleMenu();
      this.menudata.module = "GRANTSCHARITABLE";
      this.menudata.operation = "Edit";
      this.menudata.appId = id
      this.menudata.screenID = transactionID;
      this.menudata.formstate = "Draft";
      this.commonService.setModluleMenu(this.menudata);
      this.header.setHeader(this.menudata);

      this.router.navigate(['/home/grants/my-applications/application-ext/:' + id + '/genInformcharitable'], {
        skipLocationChange: true, queryParams: { module: "grants", submodule: this.menudata.module, id: transactionID, app_ext: true, screen_type: "my-applications" }
      });

    });
    this.generalInfoForm.markAsPristine();
  }



  

  uploadFiles(event): void {
    if (this.uploadedFiles == undefined || this.uploadedFiles == null) {
      this.uploadedFiles = [];
    }
    let DupFlag = false;
    let DOCUMENT_NAME = "";
    let hasUnFormat = false;
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      let file = event.target.files[i].name;
      let ext = file.match(/\.([^\.]+)$/)[1];
      let filesize = event.target.files[i].size;

      if (file != null && ((filesize > 15728640) || (ext != 'docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf'))) {
        hasUnFormat = true;
      }
      else {
        let hasValue;

        uploadFile.ID = this.NewGuid();// this.commonService.getUniqueId();
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";

        if (this.uploadedFiles?.length > 0) {
          hasValue = this.uploadedFiles?.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
        }

        if (hasValue?.length > 0) {
          DupFlag = true;
          if (DOCUMENT_NAME != "")
            DOCUMENT_NAME += "," + uploadFile.DOCUMENT_NAME;
          else
            DOCUMENT_NAME = uploadFile.DOCUMENT_NAME;

        } else {
          if (this.staticformFields.CGenInfo_AddlDocReq.IS_MULTISELECT) {
            this.uploadedFiles.push(uploadFile);
          } else {
            if (this.generalInfoForm.controls["ID"].value != null) {
              this.uploadedFiles.forEach((item) => {
                item.Status = "Delete";
              });
              this.uploadedFiles.push(uploadFile);
            } else {
              this.uploadedFiles = [];
              this.uploadedFiles.push(uploadFile);
            }
          }
        }
      }
    }
    if (DupFlag)
      this.commonService.ValidationBanner("File already exists with " + DOCUMENT_NAME + " Please update the unique file name");
    if (hasUnFormat) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details.");
    }
  }

  

  DownloadFile(fileID) {
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }


  NewGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
      .replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode, this.appid)
      .subscribe({
        next: summary => {
          this.staticformFields = summary["Data"];          
          let vx = [{ label: "Select", value: null, checked: true }].concat(this.staticformFields?.IS_PRE_REC_FUND?.GROUP_VALUES_LIST);
          this.previouslyReceivedFundDD$ = of(vx);

          if (this.staticformFields?.PROGRAM_START_DATE?.IS_PASTDATES_ALLOWED) { this.minPStartDate = new Date(); this.minPStartDate.setHours(0, 0, 0, 0) }
          else this.minPStartDate = null

          if (this.staticformFields?.PROGRAM_END_DATE?.IS_PASTDATES_ALLOWED) { this.minPEndDate = new Date(); this.minPEndDate.setHours(0, 0, 0, 0) }
          else this.minPEndDate = null;

        }
      });
  }

  CompareDates(olddate: any, newDate: any): boolean {

    if (olddate != '' && olddate != undefined && olddate != null) {

      let oDt = olddate.getDate().toString() + olddate.getMonth().toString() + olddate.getFullYear().toString();
      let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
      if (oDt == nDt) { return true }
      else { return false }
    }
    else
      return false
  }


  startDateSelect(event) {
    // this.minPEndDate = event;
    this.isStartDateModified = true
    this.Full_Start_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isStartDateModified
    }
  }

  endDateSelect(event) {
    // this.maxPStartDate = event;
    this.isEndDateModified = true;
    this.Full_End_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.isEndDateModified
    }
  }

  GetStartDate(): DateObject {
    let formModel = this.generalInfoForm.getRawValue();
    const lDate = new Date(formModel.PROGRAM_START_DATE);
    // const lDate = formModel.PROGRAM_START_DATE== null?null :  
    if ((this.CompareDates(this.ProgramStartDate, lDate) || this.Full_Start_Date == null || this.Full_Start_Date == undefined) &&
      formModel.PROGRAM_START_DATE != null) {
      this.Full_Start_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false
      }
    }
    else {
      this.Full_Start_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: true,
        HasValue: true,
        IsDateModified: true
      }
    }
    return this.Full_Start_Date
  }

  GetEndDate(): DateObject {
    const formModel = this.generalInfoForm.value;
    // const lDate = new Date(formModel.PROGRAM_END_DATE);
    const lDate = new Date(formModel.PROGRAM_END_DATE);
    if ((this.CompareDates(this.ProgramEndDate, lDate) || this.Full_End_Date == null || this.Full_End_Date == undefined) && formModel.PROGRAM_END_DATE != null)
      this.Full_End_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: true,
        HasValue: true,
        IsDateModified: false
      }
    else {
      this.Full_End_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: true,
        HasValue: true,
        IsDateModified: true
      }
    }
    return this.Full_End_Date;
  }

  

  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.appid, this.appid, (ScreenData) => {
      this.SCREEN_MODEL = ScreenData;
      this.ScreenName = this.SCREEN_MODEL?.NAME;
      this.staticformFields = ScreenData["SCREEN_CONTROL"];     
      this.fetchGeneralInfo();
      if(this.grantsapp?.STATUS > 1 ){
        this.isSubmitVisible = this.SCREEN_MODEL.HAS_SAVE_SUBMIT == 1 ? true :false;       
      }  
    });
  }

  
  validateControls(): boolean {
    let isValid = true;
    let message = "";

    if(this.grantsapp?.STATUS >= 2){

    this.staticformFields.forEach((item) => {
      if (item.IS_MANDATORY && item.IS_Dependent_Enabled == true && item.IS_Dependent_Display == true) {
        switch (item.CONTROL) {
          case 1:
          case 2:
          case 3:
          case 5:
          case 4:
          case 11:
            if (!item.ControlValue) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 10:
            if (!(item.ControlValue) || (item.ControlValue != null && item.ControlValue.length == 0)) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 6:
            let seletedItem = "";
            for (let c = 0; c < item.SourceItems.length; c++) {
              if (item.SourceItems[c].Checked == true) {
                if (seletedItem == "")
                  seletedItem = item.SourceItems[c].value;
                else
                  seletedItem = seletedItem + "," + item.SourceItems[c].value;
              }
            }
            item.ControlValue = seletedItem;
            if (!item.ControlValue) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;

          case 7:
            if (!item.ControlValue) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 8:
            if (item.UploadFiles != null && item.UploadFiles != undefined && item.UploadFiles.length == 0) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 9:
            break;
        }
      }
    });

    if (isValid) {
      let inactiveValueControls = this.commonService.checkInactiveRecordState(this.staticformFields);
      if (inactiveValueControls && inactiveValueControls.length > 0) {
        isValid = false;
        let dataMsg = inactiveValueControls.join("</br>");
        this.commonService.ValidationBanner(dataMsg);
      }
    }
  }
      else {
        // Check at least one field value exists
        isValid = this.commonService.checkHasSingleControlValue(this.staticformFields);
        if (!isValid) {
          message += `Please enter at least one field. <br/>`;
        }
      }

    if (!isValid)
      this.commonService.ValidationBanner(message);
    return isValid;
  }

  singleonChange($event, question) {
    this.IsFormToched = true;
    this.UpdateParentChildDetails(question);
    this.ApplyConditions($event, question, "Y");
  }

  ApplyConditions($event, question, makeNull) {
    let value = $event.value;
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      if (item.Mapped_Control_Value == value) {
        item.ConditionsList.forEach((otemCon) => {
          switch (otemCon.Mapped_Condtion) {
            case "1": //display
              if (displayControlIDS.length == 0) {
                displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disCntrIds && disCntrIds.length > 0) {
                  disCntrIds.forEach((id) => {
                    if (!displayControlIDS.includes(id)) {
                      displayControlIDS.push(id);
                    }
                  })
                }
              }

              break;
            case "2": //enabled
              if (enableControlIDS.length == 0) {
                enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (enableCntrIds && enableCntrIds.length > 0) {
                  enableCntrIds.forEach((id) => {
                    if (!enableControlIDS.includes(id)) {
                      enableControlIDS.push(id);
                    }
                  })
                }
              }
              break;
            case "3": //hide
              if (hideControlIDS.length == 0) {
                hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (hideCntrIds && hideCntrIds.length > 0) {
                  hideCntrIds.forEach((id) => {
                    if (!hideControlIDS.includes(id)) {
                      hideControlIDS.push(id);
                    }
                  })
                }
              }

              break;

            case "4": //disabled
              if (disbledControlIDS.length == 0) {
                disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disableCntrIds && disableCntrIds.length > 0) {
                  disableCntrIds.forEach((id) => {
                    if (!disbledControlIDS.includes(id)) {
                      disbledControlIDS.push(id);
                    }
                  })
                }
              }
              break;
          }

        });
      }
    })
    //default
    if (value != "") {
      this.staticformFields.forEach((con) => {

        if (displayControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = true;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (hideControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = false;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (enableControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = true;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (disbledControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = false;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }

      });
    }
    else {
      this.UpdateParentChildDetails(question);
    }

    if (makeNull == "Y") {
      this.staticformFields.forEach((con) => {
        if (con.IS_Dependent_Display == false) {
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "8") {
            con.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            });
          }
          if (con.CONTROL == "6") {
            con.SourceItems.forEach((item) => {
              item.Checked = false;
            });
          }
        }
        if (con.IS_Dependent_Display == true) {

        }
        if (con.IS_Dependent_Enabled == false) {
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "8") {
            con.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            });
          }
          if (con.CONTROL == "6") {
            con.SourceItems.forEach((item) => {
              item.Checked = false;
            });
          }
        }
        if (con.IS_Dependent_Enabled == true) {

        }
      });
    }
  }

  UpdateParentChildDetails(question: any) {
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      item.ConditionsList.forEach((otemCon) => {
        switch (otemCon.Mapped_Condtion) {
          case "1": //display
            if (displayControlIDS.length == 0) {
              displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disCntrIds && disCntrIds.length > 0) {
                disCntrIds.forEach((id) => {
                  if (!displayControlIDS.includes(id)) {
                    displayControlIDS.push(id);
                  }
                })
              }
            }

            break;
          case "2": //enabled

            if (enableControlIDS.length == 0) {
              enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (enableCntrIds && enableCntrIds.length > 0) {
                enableCntrIds.forEach((id) => {
                  if (!enableControlIDS.includes(id)) {
                    enableControlIDS.push(id);
                  }
                })
              }
            }
            break;
          case "3": //hide

            if (hideControlIDS.length == 0) {
              hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (hideCntrIds && hideCntrIds.length > 0) {
                hideCntrIds.forEach((id) => {
                  if (!hideControlIDS.includes(id)) {
                    hideControlIDS.push(id);
                  }
                })
              }
            }
            break;

          case "4": //disabled
            if (disbledControlIDS.length == 0) {
              disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disableCntrIds && disableCntrIds.length > 0) {
                disableCntrIds.forEach((id) => {
                  if (!disbledControlIDS.includes(id)) {
                    disbledControlIDS.push(id);
                  }
                })
              }
            }
            break;
        }
      });
    })

    this.staticformFields.forEach((con) => {
      if (displayControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = false;
      }
      if (hideControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = true;
      }
      if (enableControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = false;
      }
      if (disbledControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = true;
      }
    });

  }
  DateSelect(event, question) {
    this.IsFormToched = true;
    this.isDateModified = true;
    this.Full_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isDateModified
    }
    question.dynamicDateobj = this.Full_Date;
  }

  OpenFile(item: Document_Upload_File): void {
    if (item.Status == "Edit") {
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);
    }
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }

  uploadchange(event, ques: SCREEN_CONTROL): void {
    //let Flag = true;

    let Isexe = false;
    let Is5oMB = false;

    if (ques.UploadFiles == undefined || ques.UploadFiles == null)
      ques.UploadFiles = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      let file = event.target.files[i].name;
      let ext = file.match(/\.([^\.]+)$/)[1];
      let filesize = event.target.files[i].size;

      if (file != null && (ext == 'exe')) {
        Isexe = true;
      }
      else if (file != null && ((filesize > 52428800))) {
        Is5oMB = true;
      }
      else {
        this.saveTempFiles(event.target.files[i]).subscribe((result: any) => {
          let uploadFile = new Document_Upload_File();
          uploadFile.ID = result.Data[0].FileID;
          uploadFile.DOCUMENT_NAME = event.target.files[i].name;
          uploadFile.File = null;
          uploadFile.Status = "Add";
          uploadFile.UploadedDate = this.datepipe.transform(new Date().toUTCString(), 'dd-MMM-YYYY');
          let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
          if (hasValue.length > 0) {
            this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
          }
          else if (ques.ISALLOWMULTIPLEFILES) {
            ques.UploadFiles.push(uploadFile);
          } else {
            ques.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            })
            ques.UploadFiles.push(uploadFile);
          }
        });

      }
    }
    if (Is5oMB && Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details and Accepts maximum file size 50MB");
    }

    else if (Is5oMB) {
      this.commonService.ValidationBanner("Accepts maximum file size 50MB");
    }

    else if (Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
    }
    else {

    }
  }

  saveTempFiles(selectedFiles: any) {
    const formData = new FormData();
    formData.append(`files`, selectedFiles);
    return this.fileService.uploadMultiFiles(formData, "");
  }

  changeVal($event, question) {
    question.NotimesChanged = question.NotimesChanged + 1;
    question.IsTouched = true;
    if (question.NotimesChanged >= 2)
      this.IsFormToched = true;

    setTimeout(() => {
      let selectedControl = question.ControlValue;
      if (selectedControl != "" && selectedControl != undefined && selectedControl != null) {
        let controlLabel = question.SourceItems.filter((item) => {
          return selectedControl.indexOf(item.value) > -1;
        })
        let labellist = [];
        controlLabel.forEach((item) => {
          labellist.push(item.label);
        });
        this.tooltipValue = labellist.join(",");
      }
      else {
        this.tooltipValue = "";
      }

    }, 200);

  }
  DeleteUpload(file, ques: SCREEN_CONTROL): void {
    this.IsFormToched = true;
    let code = file.ID;
    if (file.Status == "Add") {
      ques.UploadFiles = ques.UploadFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x) => {
        if (x["Status"] == 2 && x["Data"] == false) {
          this.commonService.ValidationBanner(x["Message"]);
        }
        else {
          file.Status = "Delete";
        }
      });

    }
  }
  BindDataToDynamicControls() {
    if (this.appid != null && this.appid != undefined && this.appid != "") {
      let sr = new ScreenResponseModel();
      sr.Id = "GCH01";
      sr.RowId = this.appid;
      sr.AppId = this.appid;
      this.summaryService.getScreenResponse(sr).subscribe(summary => {
        this.submittedresponse = summary;
        if (this.submittedresponse != null && this.submittedresponse.length > 0) {
          for (let i = 0; i < this.staticformFields.length; i++) {
            var response = this.submittedresponse.filter(x => x.SCREEN_CONTROL_ID == this.staticformFields[i].ID);

            if (response != null && response.length > 0) {
              if (this.staticformFields[i].CONTROL == '6') {
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                  var options = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(",");
                  if (this.staticformFields[i].SourceItems != null && this.staticformFields[i].SourceItems != undefined) {
                    for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                      if (options.indexOf(this.staticformFields[i].SourceItems[c].value) > -1) {
                        this.staticformFields[i].SourceItems[c].Checked = true;
                      }
                      else {
                        this.staticformFields[i].SourceItems[c].Checked = false;
                      }
                    }
                  }

                }
              }
              else if (this.staticformFields[i].CONTROL == '10') {
                this.staticformFields[i].NotimesChanged = 0;
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = [];

                  var options1 = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(',');
                  options1.forEach((item) => {
                    this.staticformFields[i].ControlValue.push(item);
                  });
                  this.staticformFields[i].SUBFIELDNAME = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                }
                else {
                  this.staticformFields[i].ControlValue = [];
                }
              }
              else if (this.staticformFields[i].CONTROL == '5') {
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "" && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined) {
                  let formd = new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                  this.staticformFields[i].ControlValue = formd;

                  if (this.staticformFields[i].DATEFORMATE == 'DD-MMM-YYYY') {
                    let formd = this.commonService.getdisplayedDate(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                    this.staticformFields[i].ControlValue = formd;
                  }

                }

              }
              else {
                this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
              }
              this.staticformFields[i].UploadFiles = response[0].UploadFiles;
              if (this.staticformFields[i].CONTROL == '4') {
                this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
              }
            }

          }
        }

      });
    }
  }
  BindDataToStaticControls(MainObjData: any): any {
    for (var i = 0; i < this.staticformFields.length; i++) {
      switch (this.staticformFields[i].FIELD_CODE) {
        case "APPLICATION_TITLE":
          this.staticformFields[i].ControlValue = MainObjData.APPLICATION_TITLE;
          break;
        case "THERAPEUTIC_AREA_ID":
          this.staticformFields[i].ControlValue = MainObjData.THERAPEUTIC_AREA_ID;
          break;
        case "ORG_MISSION_STATEMENT":
          this.staticformFields[i].ControlValue = MainObjData.ORG_MISSION_STATEMENT;
          break;
        case "ORG_ANNUAL_OPERATING":
          this.staticformFields[i].ControlValue = MainObjData.ORG_ANNUAL_OPERATING;
          break;
        case "GEO_FOCUS_ORG":
          this.staticformFields[i].ControlValue = MainObjData.GEO_FOCUS_ORG;
          break;
        case "REQUESTED_PROGRAM":
          this.staticformFields[i].ControlValue = MainObjData.REQUESTED_PROGRAM;
          break;
        case "BRIEF_DESC_PROGRAM":
          this.staticformFields[i].ControlValue = MainObjData.BRIEF_DESC_PROGRAM;
          break;
        case "GOALS_OBJ_PROGRAM":
          this.staticformFields[i].ControlValue = MainObjData.GOALS_OBJ_PROGRAM;
          break;
        case "GEO_FOCUS_REQUEST":
          this.staticformFields[i].ControlValue = MainObjData.GEO_FOCUS_REQUEST;
          break;
        case "PROGRAM_START_DATE":
          if (MainObjData.PROGRAM_START_DATE != null) {
            this.staticformFields[i].ControlValue = new Date(MainObjData.PROGRAM_START_DATE);
          }
          else {
            this.staticformFields[i].ControlValue = null;
          }
          break;
        case "PROGRAM_END_DATE":
          if (MainObjData.PROGRAM_END_DATE != null) {
            this.staticformFields[i].ControlValue = new Date(MainObjData.PROGRAM_END_DATE);
          }
          else {
            this.staticformFields[i].ControlValue = null;
          }
          break;
        case "REQUEST_AMOUNT":
          this.staticformFields[i].ControlValue = MainObjData.REQUEST_AMOUNT;
          break;
        case "REQUEST_PROPOSAL":
          this.staticformFields[i].ControlValue = MainObjData.REQUEST_PROPOSAL;
          break;
        case "PROPOSED_BUDGET":
          this.staticformFields[i].ControlValue = MainObjData.PROPOSED_BUDGET;
          break;
        case "ANNUAL_BUDGET":
          this.staticformFields[i].ControlValue = MainObjData.ANNUAL_BUDGET;
          break;
        case "IS_PRE_REC_FUND":
          this.staticformFields[i].ControlValue = MainObjData.IS_PRE_REC_FUND;
          break;
          case "CGenInfo_AddlDocReq":         
             this.staticformFields[i].UploadFiles = MainObjData.UploadedDocuments;
          break;

      }

      if (this.staticformFields[i].CONTROL == '4') {
        this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
      }
    }

  }
}